import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from '@saexpeditions/sdk/web/loader';
import {
  EnvironmentBannerComponent,
  type EnvironmentMode,
} from '@saexpeditions/sdk/web/components';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [RouterOutlet, LoaderComponent, EnvironmentBannerComponent],
  host: {
    class: 'h-screen flex flex-col overflow-hidden',
  },
})
export class AppComponent {
  /** Resolved from the app's own environment config and handed to the banner. */
  protected readonly environmentMode: EnvironmentMode = environment.production
    ? 'production'
    : environment.development
      ? 'development'
      : 'staging';
}
